import { createActions } from "redux-actions";
import { createRequestAction } from "../utils";

const invoicesActions = {
  ...createActions({
    GET_INVOICES: (from, limit, accountId, kind, govStatus, emailStatus) => ({
      from,
      limit,
      accountId,
      kind,
      govStatus,
      emailStatus,
    }),
    GET_CHARGEBEE_INVOICES: (accountId, limit) => ({ accountId, limit }),
    GET_CHARGEBEE_CREDIT_NOTES: (accountId, limit) => ({ accountId, limit }),
    TRIGGER_ACTIONS: (invoiceId, actions) => ({ invoiceId, actions }),
    TRIGGER_CREDIT_NOTE_ACTIONS: (creditNoteId, actions) => ({ creditNoteId, actions }),
  }),
  ...createRequestAction("GET_INVOICES"),
  ...createRequestAction("GET_CHARGEBEE_INVOICES"),
  ...createRequestAction("GET_CHARGEBEE_CREDIT_NOTES"),
  ...createRequestAction("TRIGGER_ACTIONS"),
  ...createRequestAction("TRIGGER_CREDIT_NOTE_ACTIONS"),
  CURRENT_PAGE: "INVOICES_CURRENT_PAGE",
  SET_SOURCE: "INVOICES_SET_SOURCE",
};

export default invoicesActions;